import React from "react";

function SuccessTick(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.29272 7.99993C1.29272 4.29564 4.29564 1.29272 7.99993 1.29272C11.7042 1.29272 14.7071 4.29564 14.7071 7.99993C14.7071 11.7042 11.7042 14.7071 7.99993 14.7071C4.29564 14.7071 1.29272 11.7042 1.29272 7.99993ZM11.5967 6.19132C11.792 5.99606 11.792 5.67948 11.5967 5.48422C11.4015 5.28895 11.0849 5.28895 10.8896 5.48422L6.91885 9.45499L5.11024 7.64638C4.91498 7.45112 4.5984 7.45112 4.40314 7.64638C4.20787 7.84164 4.20787 8.15822 4.40314 8.35349L6.5653 10.5156C6.76056 10.7109 7.07714 10.7109 7.2724 10.5156L11.5967 6.19132Z"
        fill="#228568"
      />
    </svg>
  );
}

const MemoSuccessTick = React.memo(SuccessTick);
export default MemoSuccessTick;
